export class TrackingParameters {
    constructor(
        public Source: string = null,
        public Campaign: string = null,
        public AdGroup: string = null,
        public Keyword: string = null,
        public AdCopy: string = null,
        public Device: string = null,
        public Medium: string = null,
        public Content: string = null
    ) { }
}
